import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  const respData = {
    id: data?.id?.toString() ?? '',
    entityId: data?.entityId ?? 0,
    bankName: data?.bankName ?? '',
    entityCode: data?.entityCode ?? '',
    rpslCode: data?.rpslCode ?? '',
    status: data?.status ?? false,
  }

  return respData
}

const getNetbankingById = (id: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.nBMappingById),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      id,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getNetbankingById }
